import React from "react";
import { Button, SectionCardStraightStyled, SectionTop } from "../../..";
import styled from "styled-components";
import { programsData } from "../../../../assets/data/aboutUsData";

export default function ProgramsSection({ data }) {
	return (
		<SectionWrapper>
			<div className="cont">
				<SectionTop heading="Our Programs" />

				<SectionCardStraightStyled data={programsData} />

				<div className="btn-container">
					<Button wide linkTo="/about-us/our-programs">
						See more
					</Button>
				</div>
			</div>
		</SectionWrapper>
	);
}

const SectionWrapper = styled.section`
	padding-right: 0 !important;
	padding-left: 0 !important;

	.cont {
		width: 100%;
		padding: 4rem 7.5rem;

		background-color: #faf5ff;

		h2 {
			width: 100%;
		}

		.btn-container {
			width: fit-content;
			margin: 3rem auto 0;
		}
	}

	@media (max-width: 768px) {
		padding-top: 3.1rem !important;
		padding-right: 0 !important;
		padding-left: 0 !important;

		.cont {
			padding: 2.4rem 1.3rem;
		}
	}
`;
